import { IDashboardMetadata } from '../dashboard-metadata.service';
import { countryHitRateIndicator, FULL_HEIGHT_GRID, HIT_RATE_FIXED_FILTERS, HIT_RATE_MAPPINGS } from './shared-dashboard.config';
import {
  HitRateDashboardFiltersComponent,
  HitRateType
} from '../filters/hit-rate/hit-rate-dashboard-filters.component';

const WEBSHOP_HIT_RATE_COLUMNS = [
  {
    name: 'Countryhitrate',
    groupingSequence: 0
  },
  {
    name: 'Desprnm',
    groupingSequence: 1
  },
  'Webshopsetup',
  'Desprst_ds',
  'Decounm',
  'Deconti',
  'Pacomnm',
  'Denrusr',
  'Btaddus',
  'Deordpr_ds',
  'Deexpoy',
  'Detotal',
  'Detotgo',
  'Detotlo',
  'Detotgl',
  'Improdt',
  'Icprodt',
  'Losprst_ds',
  'Lostaco',
  'Losprdt',
  'Delamco',
  'Delamnm',
  'Delamcn',
  'Vglname',
  'Gblname',
  'Lglname',
  'Denamnm',
  'Destaco'
];

export const WEBSHOP_HIT_RATE_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'Webshop Hit Rate KPI',
  filterComponent: {
    name: HitRateDashboardFiltersComponent,
    inputs: {
      hitRateType: HitRateType.CUSTOMER
    }
  },
  mapping: {
    Desprnm: 'customer.id',
    Decusid: 'customerCompany.id',
    Lacgrid: 'lamGroup.id',
    Delamco: 'lamCompany.id',
    Delamcn: 'lamContact.id',
    Delamnm: 'lam.id',
    Decounm: 'country.id',
    Gblname: 'gbdm.id',
    Decsunm: 'subCompany.id',
    Desk: 'gbdmDesk.id',
    Deconti: 'geography.name',
    Pacomnm: 'bp.companyCountryId',
    Pacgrid: 'bpGroup.id',
    Devenid: 'oem.id',
    Vnamid: 'vnam.id',
    Amlname: 'arm.id'
  },
  reports: [
    {
      id: 175,
      key: 'CUSTOMER_IN_COUNTRIES',
      comments: '1 customer in all countries',
      columns: WEBSHOP_HIT_RATE_COLUMNS,
      gridHeight: FULL_HEIGHT_GRID,
      partialRender: true,
      fixedFilters: HIT_RATE_FIXED_FILTERS,
      mapping: HIT_RATE_MAPPINGS,
      indicatorFn: countryHitRateIndicator
    }
  ]
};